var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LicenseReviewed } from '../MedFile';
import { list, primitive } from '../../../../../utils/serializr/serializr';
import { memoize } from '../../../../../utils/mobx/decorators/memoize';
import { withDefault } from '../../../../../utils/serializr/schema/middle/withDefault';
import { MediaSourceDatabase } from '../../../../learnware/LearnwareEnums';
import { editable, editObservable } from '../../../../../utils/mobx/decorators/editable';
import { UTCdate } from '../../../../../utils/serializr/schema/inner/UTCdate';
export class MedFileSource {
    parent;
    /** eg. https://creativecommons.org/licenses/by-sa/4.0/deed.en */
    licenseUrl = '';
    /** tells if there is for sure a valid license for this file */
    licenseReviewed = LicenseReviewed.Yes;
    /** short display version of the license */
    manualLicenseDisplay = '';
    /** Name of the medium creator  / rights owner */
    rightHolder = '';
    /** Email of the user who inserted the medium */
    editorEmail = '';
    /** UserId of the user who inserted the medium */
    editorUserId = 0;
    /** From which database does the file come from (e.g. openclipart) */
    sourceDatabase = MediaSourceDatabase.Unknown;
    /** Id of the file in source db */
    sourceId = '';
    /** Frontdoor url of the file in source db */
    sourcePageUrl = '';
    /** File url in source db */
    sourceFileUrl = '';
    /** When was the file created by the author */
    mediumCreationDate = new Date();
    /** When was the file uploaded first */
    uploadDate = new Date();
    /** What is this medium about? */
    tags = [];
    /** What does this medium show? */
    description = '';
    /** Any notes by editors */
    note = '';
    duplicates = '';
    /** TextAlternative to Medium */
    alternativeText = '';
    constructor(parent) {
        editObservable(this);
        this.parent = parent;
    }
    get medFile() {
        return this.parent;
    }
    static get serializeInfo() {
        return {
            props: {
                licenseUrl: withDefault(primitive, ''),
                licenseReviewed: withDefault(primitive, ''),
                manualLicenseDisplay: withDefault(primitive, ''),
                rightHolder: withDefault(primitive, ''),
                editorEmail: withDefault(primitive, ''),
                editorUserId: withDefault(primitive, 0),
                sourceDatabase: withDefault(primitive, 'none'),
                sourceId: withDefault(primitive, ''),
                sourcePageUrl: withDefault(primitive, ''),
                sourceFileUrl: withDefault(primitive, ''),
                mediumCreationDate: UTCdate(),
                uploadDate: UTCdate(),
                tags: withDefault(list(primitive), []),
                description: withDefault(primitive, ''),
                note: withDefault(primitive, ''),
                duplicates: withDefault(primitive, ''),
                alternativeText: withDefault(primitive, ''),
            },
        };
    }
}
__decorate([
    editable()
], MedFileSource.prototype, "licenseUrl", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "licenseReviewed", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "manualLicenseDisplay", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "rightHolder", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "editorEmail", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "editorUserId", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "sourceDatabase", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "sourceId", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "sourcePageUrl", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "sourceFileUrl", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "mediumCreationDate", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "uploadDate", void 0);
__decorate([
    editable('shallow')
], MedFileSource.prototype, "tags", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "description", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "note", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "duplicates", void 0);
__decorate([
    editable()
], MedFileSource.prototype, "alternativeText", void 0);
__decorate([
    memoize
], MedFileSource, "serializeInfo", null);
